/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { FC } from "react";
import NewDynamicPatientStepperForm from "components/forms/patient/DynamicPatientStepperForm";
import { PatientInterface } from "@malmur-technologies/medicalsystem-shared";

interface NewPatientDataContentProps {
  disableRedirect?: boolean;
  onPatientCreated?: (patient: Partial<PatientInterface>) => void;
}

/**
 * Component for creating new patient records.
 * Displays multi-step patient registration form with dynamic fields.
 * 
 * @param disableRedirect - When true, prevents navigation after patient creation (useful for modal usage)
 * @param onPatientCreated - Callback fired after patient is successfully created
 * @returns New patient stepper form component
 */
const NewPatientDataContent: FC<NewPatientDataContentProps> = ({ disableRedirect, onPatientCreated }) => {
  return <NewDynamicPatientStepperForm disableRedirect={disableRedirect} onPatientCreated={onPatientCreated} />;
};

export default NewPatientDataContent;
